import { PropsWithChildren } from "react";

import { tw } from "~/utils";

interface TitleProps extends PropsWithChildren {
  className?: string;
}

export const Title = ({ children, className }: TitleProps) => {
  return (
    <h1
      className={tw(
        "text-indigo font-ivy md:text-4-5xl mb-4 text-3xl",
        className,
      )}
    >
      {children}
    </h1>
  );
};
